"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateCloudViewerUrl = void 0;
var constants_1 = require("../../utils/constants");
var IdValidation_1 = require("../../utils/IdValidation");
var prepareRegExps_1 = require("../../utils/prepareRegExps");
var regexps_1 = require("../../utils/regexps");
/** Переводит объект в query строку */
var objectToQuery = function (object) {
    return Object.keys(object)
        .map(function (key) { return "".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(object[key])); })
        .join('&');
};
/** Составляет урл на облачный просмотрщик */
var buildCloudViewerUrl = function (_a) {
    var host = _a.host, messageId = _a.messageId, attachId = _a.attachId, queryParams = _a.queryParams;
    var idsPart = encodeURIComponent("".concat(messageId, ";").concat(attachId));
    var encodedQueryParams = objectToQuery(queryParams);
    return "https://".concat(host, "/attaches/").concat(idsPart, "?").concat(encodedQueryParams);
};
/** Генерирует ссылку на облачный просмотрщик */
var generateCloudViewerUrl = function (_a, _b) {
    var encodedAttachId = _a.encodedAttachId, messageId = _a.messageId, queryParams = _a.queryParams, _c = _a.host, host = _c === void 0 ? 'cloud.mail.ru' : _c, attachType = _a.attachType;
    var _d = _b === void 0 ? {} : _b, _e = _d.validateIds, validateIds = _e === void 0 ? true : _e, _f = _d.regExps, regExps = _f === void 0 ? regexps_1.defaultRegExps : _f;
    var decodedAttachId;
    try {
        decodedAttachId = decodeURIComponent(encodedAttachId);
    }
    catch (error) {
        return {
            result: null,
            error: constants_1.Errors.Decode,
        };
    }
    /** Урл должен содержать почту пользователя */
    if (!queryParams[constants_1.ParamsKeys.XEmail]) {
        return {
            result: null,
            error: constants_1.Errors.Email,
        };
    }
    if (validateIds && attachType) {
        var _g = (0, prepareRegExps_1.prepareRegExps)(regExps), attachesRegExps = _g.attachesRegExps, messageIdsRegExps = _g.messageIdsRegExps;
        /** Проверяем валидность айди аттача */
        var isAttachIdValid = (0, IdValidation_1.validateAttachId)(attachType, decodedAttachId, attachesRegExps);
        if (!isAttachIdValid) {
            return {
                result: null,
                error: constants_1.Errors.AttachId,
            };
        }
        /** Проверяем валидность айди письма */
        var isMessageIdValid = (0, IdValidation_1.validateMessageId)(attachType, messageId, messageIdsRegExps);
        if (!isMessageIdValid) {
            return {
                result: null,
                error: constants_1.Errors.MessageId,
            };
        }
    }
    /** Урл, который открывается при закрытии облачного просмотрщика */
    var backUrl = queryParams[constants_1.ParamsKeys.BackUrl];
    if (backUrl) {
        try {
            queryParams[constants_1.ParamsKeys.BackUrl] = decodeURIComponent(backUrl);
        }
        catch (error) { }
    }
    return {
        result: buildCloudViewerUrl({
            host: host,
            messageId: messageId,
            attachId: decodedAttachId,
            queryParams: queryParams,
        }),
    };
};
exports.generateCloudViewerUrl = generateCloudViewerUrl;
//# sourceMappingURL=generate.js.map